import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './styles.css';
import logo from '../../images/logoOAB.png';

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <header className="header">
      <div className="logo">
        <img src={logo} alt="Logo OAB Rio Grande do Sul" />
        <p>São Leopoldo</p>
      </div>
      <div className="tabs">
        <button
          className={`tab ${location.pathname === '/' ? 'active' : ''}`}
          onClick={() => navigate('/')}
        >
          Reserva de Salas
        </button>
        <button
          className={`tab ${location.pathname === '/relatorios' ? 'active' : ''}`}
          onClick={() => navigate('/relatorios')}
        >
          Relatórios
        </button>
      </div>
    </header>
  );
};

export default Header;
